import { useState, useEffect, lazy, Suspense } from 'react';
import { useTheme, styled } from '@mui/material/styles';
import Scroll from 'react-scroll';
import { Box } from '@mui/material';
// import {Main} from '~/content/layouts/Main/Main';
import { Container } from '~/content/components/Container';
// import { Contact, Form, Hero, MeetingRequest, Subscription } from './components';
// import Contact from './contact';
// import Hero from './hero';
// import MeetingRequest from './meetingRequest';
// import Subscription from './subscription';
import { trackPageview } from '~/utils/plausible';
const Contact = lazy(() => import('./contact.tsx'));
const MeetingRequest = lazy(() => import('./meetingRequest.tsx'));

const ContactPage = (): JSX.Element => {
	const theme = useTheme();
	// const { mode } = theme.palette;
	// const isXs = useMediaQuery(theme.breakpoints.up('xs'), {
	// 	defaultMatches: true
	// });
	// const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
	// 	defaultMatches: true
	// });
	// const isMd = useMediaQuery(theme.breakpoints.up('md'), {
	// 	defaultMatches: true
	// });
	const [activeSection, setActiveSection] = useState<any>(null); //? start with video-call component
	useEffect(() => {
		trackPageview();
	}, []);
	useEffect(() => {
		const scroller = () => {
			Scroll.scroller.scrollTo('video-call', {
				duration: 1500,
				delay: 250,
				smooth: true,
				// containerId: 'ContainerElementID',
				// offset: 50 // Scrolls to element + 50 pixels down the page
			});
		};

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.get('scrollTo') === 'video-call') {
			scroller();
			setActiveSection('video-call');
		}
		if (urlParams.get('scrollTo') === 'contact-form') {
			scroller();
			setActiveSection('contact-form');
		}
		if (urlParams.get('utm_medium') === 'flyer') {
			scroller();
			setActiveSection('video-call');
		}
		// window.addEventListener('load', () => {
		//   const urlParams = new URLSearchParams(window.location.search);
		//   console.log({ urlParams });
		// });
	}, []);

	return (
		<>
			{/* <Box
				sx={{
				position: 'relative',
				backgroundColor: theme.palette.alternate.main,
				backgroundImage: `linear-gradient(120deg, ${theme.palette.alternate.dark} 0%, ${theme.palette.background.paper} 100%)`,
				marginTop: -13,
				paddingTop: 13,
				}}
			>
				<Container>
				<Hero />
				</Container>
			</Box> */}
			<Contact />
			<Box position={'relative'}>
				<Scroll.Element
					name='video-call'
					style={{
						position: 'absolute',
						// top: isMd ? -60 : -75
						top: -75,
					}}
				>
					{' '}
				</Scroll.Element>
			</Box>

			<Box bgcolor={'alternate.main'}>
				<Container>
					<MeetingRequest activeSection={activeSection} />
				</Container>
			</Box>
			{/* <Container>
        <Subscription />
      </Container> */}
		</>
	);
};

export default ContactPage;
